/* SPDX-License-Identifier: Apache-2.0 */
/* SPDX-FileCopyrightText: 2021-2023 OKTET Labs Ltd. */
export const enum HistoryLinearColumns {
	Links = 'links',
	StartDuration = 'start-duration',
	Metadata = 'metadata',
	Tags = 'tags',
	ExpectedResults = 'expected-results',
	ObtainedResults = 'obtained-results',
	Parameters = 'parameters'
}
